import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export async function fetchMenu() {
  const { data } = await api.get("/menu");
  return data.items;
}

export async function fetchSlots(date) {
  const { data } = await api.get("/pickup-slots", { params: date ? { date } : {} });
  return data.slots;
}

export async function fetchAvailableDates() {
  const { data } = await api.get("/available-dates");
  return data.dates;
}

export async function fetchStatus() {
  const { data } = await api.get("/status");
  return data;
}

export async function lookupCustomerByPhone(phone) {
  const { data } = await api.get("/customer/lookup", { params: { phone } });
  return data;
}

export async function fetchKitchenSlotFills(date, token) {
  const { data } = await api.get("/kitchen/slot-fills", {
    params: { date },
    headers: { "x-kitchen-token": token },
  });
  return data;
}

export async function fetchKitchenSettings(token) {
  const { data } = await api.get("/kitchen/settings", { headers: { "x-kitchen-token": token } });
  return data;
}

export async function updateKitchenSettings(payload, token) {
  const { data } = await api.put("/kitchen/settings", payload, { headers: { "x-kitchen-token": token } });
  return data.settings;
}

export async function createOrder(payload) {
  const { data } = await api.post("/orders", payload);
  return data;
}

export async function getPaymentStatus(sessionId) {
  const { data } = await api.get(`/payments/status/${sessionId}`);
  return data;
}

export async function getOrder(orderId) {
  const { data } = await api.get(`/orders/${orderId}`);
  return data;
}

export async function kitchenLogin(password) {
  const { data } = await api.post("/kitchen/login", { password });
  return data.token;
}

export async function fetchKitchenOrders(token) {
  const { data } = await api.get("/kitchen/orders", { headers: { "x-kitchen-token": token } });
  return data.orders;
}

export async function updateOrderStatus(orderId, status, token) {
  const { data } = await api.patch(`/kitchen/orders/${orderId}`, { status }, { headers: { "x-kitchen-token": token } });
  return data;
}

export async function deleteOrder(orderId, token) {
  const { data } = await api.delete(`/kitchen/orders/${orderId}`, { headers: { "x-kitchen-token": token } });
  return data;
}

export async function deleteAllOrders(token) {
  const { data } = await api.delete(`/kitchen/orders`, { headers: { "x-kitchen-token": token } });
  return data;
}
